var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPapperParagraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1773_8482)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2573 1.6665C15.8773 1.6665 17.6373 3.46067 17.6373 6.13067V13.794C17.6373 16.4873 15.9314 18.239 13.2914 18.2557L6.88059 18.2582C4.26059 18.2582 2.49976 16.464 2.49976 13.794V6.13067C2.49976 3.4365 4.20559 1.68567 6.84559 1.66984L13.2564 1.6665H13.2573ZM13.2573 2.9165L6.84976 2.91984C4.90976 2.9315 3.74976 4.1315 3.74976 6.13067V13.794C3.74976 15.8065 4.92059 17.0082 6.87976 17.0082L13.2873 17.0057C15.2273 16.994 16.3873 15.7923 16.3873 13.794V6.13067C16.3873 4.11817 15.2173 2.9165 13.2573 2.9165ZM13.0965 12.8946C13.4415 12.8946 13.7215 13.1746 13.7215 13.5196C13.7215 13.8646 13.4415 14.1446 13.0965 14.1446H7.07984C6.73484 14.1446 6.45484 13.8646 6.45484 13.5196C6.45484 13.1746 6.73484 12.8946 7.07984 12.8946H13.0965ZM13.0965 9.40584C13.4415 9.40584 13.7215 9.68584 13.7215 10.0308C13.7215 10.3758 13.4415 10.6558 13.0965 10.6558H7.07984C6.73484 10.6558 6.45484 10.3758 6.45484 10.0308C6.45484 9.68584 6.73484 9.40584 7.07984 9.40584H13.0965ZM9.37542 5.92517C9.72042 5.92517 10.0004 6.20517 10.0004 6.55017C10.0004 6.89517 9.72042 7.17517 9.37542 7.17517H7.07959C6.73459 7.17517 6.45459 6.89517 6.45459 6.55017C6.45459 6.20517 6.73459 5.92517 7.07959 5.92517H9.37542Z",
    fill: "#1B2E4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1773_8482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPapperParagraph);
export default __webpack_public_path__ + "static/media/IconPapperParagraph.0534bc32137e511cb51a8fe07fc51a8a.svg";
export { ForwardRef as ReactComponent };